import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation, useParams } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { Header } from './components/Header';
import { Footer } from './components/Footer';
import { ServicePage } from './components/ServicePage';
import { generateSeoRoutes, services } from './routes/seoRoutes';
import { Home } from './components/Home';
import { ServiceType } from './routes/seoRoutes';
import { Toaster } from 'react-hot-toast';

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

const App: React.FC = () => {
  const seoRoutes = generateSeoRoutes();

  return (
    <HelmetProvider>
      <Router>
        <Toaster />
        <ScrollToTop />
        <div className="flex flex-col min-h-screen">
          <Header />
          <main className="flex-grow">
            <Routes>
              <Route path="/" element={<Home />} />
              {Object.entries(services).map(([serviceKey, serviceConfig]) => (
                <Route
                  key={serviceConfig.path}
                  path={`/${serviceConfig.path}-:city`}
                  element={
                    <ServicePage 
                      service={serviceKey as ServiceType} 
                      city={serviceConfig.path}
                    />
                  }
                />
              ))}
              <Route path="*" element={<Home />} />
            </Routes>
          </main>
          <Footer />
        </div>
      </Router>
    </HelmetProvider>
  );
};

export default App;